import { ContactMaterial, Material } from "cannon-es"
import * as CANNON from 'cannon-es'
import CannonDebugger from 'cannon-es-debugger'
import WorldPin from "./Pin"
import { pinMass } from "../../constants"
import WorldBall from "./Ball"
import WorldTrack from "./Track"

export default class World {
  constructor() {
    this.world
    this.material
    this.properties
    this.worldPins
    this.worldBall
    this.worldTrack
    this.init()
  }

  init(scene) {
    this.world = new CANNON.World()
    this.world.gravity.set(0,-10,0)
    this.world.broadphase = new CANNON.NaiveBroadphase()
    this.world.defaultContactMaterial.contactEquationStiffness = 1e11
    this.world.defaultContactMaterial.contactEquationRelaxation = 2
    this.world.solver.iterations = 5
    this.world.solver.tolerance = 0.001
    this.world.defaultContactMaterial.friction = 0
    this.world.defaultContactMaterial.restitution = 0.002
    this.createMaterial()

    this.addDebug(scene)
  }

  createMaterial() {
    const material = new Material('hardMaterial')
    const contact = new ContactMaterial(material, material, { friction: 0.05, restitution: 0.02 })
    this.world.addContactMaterial(contact)
    this.material = material
  }

  // createProperties() {
  //   this.properties = {
  //     pinMass: pinMass

  //   }
  // }

  linkToWorld(world) {
    this.meshWorld = world
    this.addPins(world.getPins())
    this.addBall(world.ball)
    this.addTrack(world.track)
  }

  addPins(pins) {
    this.worldPins = []
    pins.forEach(pin => {
      const worldPin = new WorldPin(this.world, this.material)
      // console.log(pin.mesh)
      worldPin.bindToMesh(pin)
      this.worldPins.push(worldPin)
    })
  }

  addBall(ball) {
    this.worldBall = new WorldBall(this.world, this.material)
    this.worldBall.bindToMesh(ball)
  }

  addTrack(track) {
    this.worldTrack = new WorldTrack(this.world, this.material)
    this.worldTrack.bindToMesh(track)
  }

  update() {
    for (const pin of this.worldPins) {
      pin.update()
    }
    this.worldBall.update()
    this.worldTrack.update()
    this.world.step(1. / 60.)
    // this.debugger.update()
  }

  addDebug(scene) {
    // this.debugger = new CannonDebugger(scene, this.world)
  }
}